import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzNoDataMaskComponent} from './yz-no-data-mask/yz-no-data-mask.component';
import {YzNoDataInlineComponent} from './yz-no-data-inline/yz-no-data-inline.component';
import {SharedModule} from "../shared.module";

const COMPONENTS = [
  YzNoDataMaskComponent,
  YzNoDataInlineComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule],
  exports: [...COMPONENTS]
})


export class EmptyModule {
}
